import actionCreators from "../../store/Auth/actionCreators";
import mainMenuActionCreators from "../../store/MainMenu/actionCreators";
import { switchCase } from "./utils";
import bugsnagClient from "../../common/services/bugsnag";
import { of, concat } from "rxjs";
import { default as notificationActions } from "../../store//Snackbar/actionCreators";

export default (action, showImmediatelly = false) => errorRes => {
    const error = errorRes.response
        ? {
              ...errorRes.response, // pass all other fields too
              error: errorRes.response.error ? errorRes.response.error : "",
              errors: errorRes.response.errors ? errorRes.response.errors : {},
          }
        : { error: "An unknown error occurred ...", errors: {} };

    const metadata =
        errorRes.status < 500
            ? {
                  ajax: {
                      error,
                      status: errorRes.status,
                      url: errorRes.request && errorRes.request.url,
                      method: errorRes.request && errorRes.request.method,
                  },
              }
            : errorRes;

    if (import.meta.env.VITE_BUGSNAG_KEY !== "DEV") {
        bugsnagClient.notify(errorRes, function(event) {
            (event.severity = errorRes.status < 500 ? "info" : "error"),
                event.addMetadata(metadata);
            event.groupingHash = `${event.errorClass}:${event.errorMessage}`;
        });
    }

    return switchCase({
        401: () => of(actionCreators.setNotAuth.create()),
        500: () => of(mainMenuActionCreators.errorPageRedirect.create()),
        503: () => of(mainMenuActionCreators.maintenancePageRedirect.create()),
    })(() =>
        showImmediatelly && error.error
            ? concat(
                  of(action(error)),
                  of(notificationActions.enqueueSnackbar.create({ message: error.error }))
              )
            : of(action(error))
    )(errorRes.status)();
};
